var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchnormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 25C16.7337 25 19.5952 23.8147 21.705 21.705C23.8147 19.5952 25 16.7337 25 13.75C25 10.7663 23.8147 7.90483 21.705 5.79505C19.5952 3.68526 16.7337 2.5 13.75 2.5C10.7663 2.5 7.90483 3.68526 5.79505 5.79505C3.68526 7.90483 2.5 10.7663 2.5 13.75C2.5 16.7337 3.68526 19.5952 5.79505 21.705C7.90483 23.8147 10.7663 25 13.75 25ZM23.6625 25.8625C24.325 27.8625 25.8375 28.0625 27 26.3125C28.0625 24.7125 27.3625 23.4 25.4375 23.4C24.0125 23.3875 23.2125 24.5 23.6625 25.8625Z",
    stroke: "#4DFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchnormal);
export default __webpack_public_path__ + "static/media/searchnormal.b3a5f37bf5c1fcbf5f8dedd494e5f308.svg";
export { ForwardRef as ReactComponent };